/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Box, LinearProgress } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import { QSTypography } from '../../../../../../shared/components/atoms';

type Props = {
  currentGroupsCount: number;
  groupsLimit: number;
};

const WAGroupLimitReached = ({ currentGroupsCount, groupsLimit }: Props) => {
  const progressValue = groupsLimit > 0 ? Math.min(100, (currentGroupsCount / groupsLimit) * 100) : 0;

  return (
    <Box
      css={css`
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0px;
        row-gap: 24px;
      `}
    >
      <Box
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          row-gap: 16px;
        `}
      >
        <Box
          css={css`
            width: 56px;
            height: 56px;
            border-radius: 8px;
            background: #f05f521f;
            display: flex;
            align-items: center;
            justify-content: center;
          `}
        >
          <LockOutlined
            sx={{
              fontSize: 28,
              color: '#F05F52',
            }}
          />
        </Box>
        <Box
          css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            row-gap: 8px;
            padding-inline: 32px;
          `}
        >
          <QSTypography
            css={css`
              color: #2d2d2d;
              font-family: Inter;
              font-size: 16px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
            `}
          >
            Cannot create new groups
          </QSTypography>
          <QSTypography
            css={css`
              color: #7a7a7a;
              text-align: center;
              font-family: Inter;
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: 140%; /* 19.6px */
            `}
          >
            You have reached your limit of {groupsLimit} total groups. You must purchase additional capacity or delete
            existing groups to create more groups.
          </QSTypography>
        </Box>
      </Box>

      <Box
        css={css`
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 16px;
        `}
      >
        <LinearProgress
          variant="determinate"
          value={progressValue}
          sx={{
            flex: 1,
            height: 4,
            borderRadius: 20,
            backgroundColor: '#f5c6c6',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#F05F52',
              borderRadius: 20,
            },
          }}
        />
        <Box
          css={css`
            display: flex;
            justify-content: flex-end;
          `}
        >
          <QSTypography
            css={css`
              color: #7a7a7a;
              font-feature-settings: 'liga' off, 'clig' off;
              font-family: var(--fontFamily, Inter);
              font-size: 12px;
              font-style: normal;
              font-weight: 500;
              line-height: 143%; /* 17.16px */
              letter-spacing: -0.144px;
            `}
          >
            {currentGroupsCount} of {groupsLimit} groups created
          </QSTypography>
        </Box>
      </Box>
    </Box>
  );
};

export default WAGroupLimitReached;
